<template>
    <div>
        <div class="field">
            <Checkbox2 :model-value="options.variant === 'changeOrRefund'" :disabled="loading" @update:model-value="changeRefundOffered">
                {{ translate("predefined_notification.refund_offer") }}
            </Checkbox2>
        </div>
        <p v-if="data.deadline?.until" class="mb-3">
            {{ translate("predefined_notification.deadline") }}
            <span class="has-text-weight-bold">{{ convertToTimezoneDateTimeMed(data.deadline.until, eventTimezone) }}</span>
        </p>
        <ExampleEmailPreview v-if="data.examplePreview" :html="data.examplePreview" />
    </div>
</template>

<script setup lang="ts">
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { translate } from "../../Common/translations";
    import { convertToTimezoneDateTimeMed } from "../../Common/dateTimeUtils";
    import type { PredefinedNotificationRequestOptions, SingleCompetitorCategoriesNotification } from "../../Api/predefinedNotifications";
    import ExampleEmailPreview from "./ExampleEmailPreview.vue";

    defineProps<{
        data: SingleCompetitorCategoriesNotification;
        eventTimezone: string;
        loading: boolean;
        options: PredefinedNotificationRequestOptions;
    }>();

    const emit = defineEmits<{
        "update:options": [PredefinedNotificationRequestOptions];
    }>();

    function changeRefundOffered(offered: boolean) {
        emit("update:options", { variant: offered ? "changeOrRefund" : "changeOnly" });
    }
</script>
